import { useTranslation } from 'react-i18next'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'
import type { InformationForUseClauseFormData } from './InformationForUseClauseForm.schema'

type InformationForUseClauseFormProps = {
  data: InformationForUseClauseFormData
  onChange: (data: InformationForUseClauseFormData) => void
  fieldErrors?: {
    number?: string
    title?: string
    content?: string
    fullStatement?: string
  }
}

export function InformationForUseClauseForm({
  data,
  onChange,
  fieldErrors,
}: InformationForUseClauseFormProps) {
  const { t } = useTranslation('standardsLibrary')

  return (
    <div className='space-y-4'>
      <div className='grid grid-cols-1 gap-3 sm:grid-cols-2'>
        <div className='space-y-2'>
          <Label htmlFor='clause-number'>{t('detail.clauseNumber')}</Label>
          <Input
            id='clause-number'
            value={data.number}
            onChange={(event) => onChange({ ...data, number: event.target.value })}
            aria-invalid={!!fieldErrors?.number}
          />
          {fieldErrors?.number && (
            <p className='text-sm text-destructive'>{fieldErrors.number}</p>
          )}
        </div>
        <div className='space-y-2'>
          <Label htmlFor='clause-title'>{t('detail.clauseTitle')}</Label>
          <Input
            id='clause-title'
            value={data.title}
            onChange={(event) => onChange({ ...data, title: event.target.value })}
            aria-invalid={!!fieldErrors?.title}
          />
          {fieldErrors?.title && (
            <p className='text-sm text-destructive'>{fieldErrors.title}</p>
          )}
        </div>
      </div>
      <div className='space-y-2'>
        <Label htmlFor='clause-content'>{t('detail.clauseContent')}</Label>
        <Textarea
          id='clause-content'
          value={data.content}
          onChange={(event) => onChange({ ...data, content: event.target.value })}
          rows={2}
          aria-invalid={!!fieldErrors?.content}
        />
        {fieldErrors?.content && (
          <p className='text-sm text-destructive'>{fieldErrors.content}</p>
        )}
      </div>
      <div className='space-y-2'>
        <Label htmlFor='clause-full-statement'>
          {t('detail.clauseFullStatement')}
        </Label>
        <Textarea
          id='clause-full-statement'
          value={data.fullStatement}
          onChange={(event) =>
            onChange({ ...data, fullStatement: event.target.value })
          }
          rows={3}
          aria-invalid={!!fieldErrors?.fullStatement}
        />
        {fieldErrors?.fullStatement && (
          <p className='text-sm text-destructive'>
            {fieldErrors.fullStatement}
          </p>
        )}
      </div>
    </div>
  )
}
